import { FC } from 'react'
import { Toaster } from 'react-hot-toast'
import { Provider } from 'react-redux'
import { Redirect, BrowserRouter as Router, Switch } from 'react-router-dom'
import { PersistGate } from 'redux-persist/integration/react'
import { ApolloProvider } from '@apollo/client'
import { AppLayout, AuthDialog, Route } from './components'
import { persistor, store } from './redux'
import { Global, ROUTES, ThemeProvider, UserContext, apolloClient } from './utils'
import {
  CheckoutView,
  CommunityView,
  ConfirmationView,
  ConnectView,
  CoursePreviewView,
  HomeView,
  LessonView
} from './views'

const App: FC = () => {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <ThemeProvider>
          <Global />
          <ApolloProvider client={apolloClient}>
            <Router>
              <Switch>
                <Route path={ROUTES.connect} component={ConnectView} exact />
                <Route path={ROUTES.confirmation} component={ConfirmationView} exact authOnly />
                <Route path={ROUTES.checkout} component={CheckoutView} exact authOnly />
                <AppLayout>
                  <Switch>
                    <Route path={ROUTES.home} component={HomeView} exact />
                    <Route path={`${ROUTES.community}/*`} component={CommunityView} />
                    <Route path={ROUTES.community} component={CommunityView} />
                    <Route path={ROUTES.course.preview} component={CoursePreviewView} exact />
                    <Route path={ROUTES.course.lesson} component={LessonView} exact authOnly />
                    <Route path="*" children={<Redirect to={ROUTES.home} />} />
                  </Switch>
                </AppLayout>
              </Switch>
              <AuthDialog />
              <UserContext />
              <Toaster position="bottom-center" containerStyle={{ zIndex: 9999999999999 }} />
              <div className="confetti" id="confetti" />
            </Router>
          </ApolloProvider>
        </ThemeProvider>
      </PersistGate>
    </Provider>
  )
}

export default App
